<template>
  <div class="show-content-overlay">
    <div class="show-content-overlay-body">
      <div>
        <div class="show-content-other-text">
          <p>申し訳ございません。<br />現在調整中となっており<br />使用できません。</p>
        </div>
        <div class="img-style">
          <img src="@/assets/アセット 9@2x.png" @click="closeModal" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
    methods: {
        closeModal() {
            this.$emit("handle-hide-content")
        }
    }
}
</script>

<style scopd>
.show-content-overlay {
  z-index: 5;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.8);
}
.show-content-overlay-body {
  background: white;
  margin: 100px 15px 0 15px;
  border-radius: 5px;
  height: 65%;
  padding: 15px;
}
.show-content-overlay-body .yes {
  background-color: orange;
  color: white;
  margin: 10px 20px 20px 0px;
}
.show-content-overlay-body .no {
  background-color: gainsboro;
}
.show-content-overlay-body .text-b {
  display: inline-block;
  margin-top: 50px;
  color: gray;
}
.show-content-other-text p {
  font-size: 1.6rem;
  margin: 30% auto;
  color: #000;
}
</style>



// WEBPACK FOOTER //
// src/components/ShowContent.vue